import { FC, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';

import qs from 'query-string';
import API from 'core/Api';

import { getUserInfo } from 'utils/auth';
import { getSubdomain } from 'utils/helpers/routing';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity } from 'utils/helpers/client';

import { useLanguageContext } from 'store/language';

import InnerWrapper from 'routes/client/reports/InnerWrapper';
import NotAuthorizedScreen from 'routes/not-authorized';
import ReportForm from './components/ReportForm';

const LeavesReportsFormSixtySeven: FC = () => {
  const { client } = useActiveClientContext();
  const { language } = useLanguageContext();

  const methods = useForm();
  const openLinkBtn = useRef<HTMLAnchorElement>(null);
  const isOperator = getSubdomain() === 'operators';
  const isForm76Active = getUserInfo().featureForm76;
  const [link, setLink] = useState<string | null>(null);

  const {
    isLoading: isLoadingDropdowns,
    error: errorDropdowns,
    data: dropdowns,
  } = useQuery<any, Error>([buildClientEntity('report-leaves-form-76-dropdowns', client)], (): Promise<any> => {
    return API.get('reports/leaves/form-76/dropdowns').then(res => {
      return res.data[language || 'bg'];
    });
  });

  const handleSubmitReport = (data: any) => {
    const formattedData = {
      month: data.period.getMonth() + 1,
      year: data.period.getFullYear(),
      user: data.user?.map((user: any) => user.value),
      group: data.group?.map((group: any) => group.value),
      status: data.status?.map((type: any) => type.value),
    };

    const queryString = qs.stringify(
      {
        ...formattedData,
      },
      { arrayFormat: 'bracket', skipNull: true }
    );
    return API.get(`reports/leaves/form-76?${queryString}`).then(res => {
      setLink(res.data.url);
    });
  };

  useEffect(() => {
    if (link) openLinkBtn?.current?.click();
  }, [link]);

  if (isForm76Active || (isOperator && client?.is_form_76)) {
    return (
      <InnerWrapper
        isLoading={isLoadingDropdowns}
        error={errorDropdowns}
      >
        {dropdowns && (
          <ReportForm
            data={dropdowns}
            methods={methods}
            onSubmit={handleSubmitReport}
          />
        )}
        {link && (
          <Link
            ref={openLinkBtn}
            to={{
              pathname: link,
            }}
            target="_blank"
            style={{ display: 'none' }}
          />
        )}
      </InnerWrapper>
    );
  }

  return <NotAuthorizedScreen />;
};

export default LeavesReportsFormSixtySeven;
